import { Surfaces } from "@netlify/sdk--ui-core";
import React from "react";
import { useNetlifySDK } from "../../use_netlify_sdk.js";

export type SiteNotificationsConfigurationSurfaceProps = {
  /**
   * Content to render within the element.
   */
  children?: React.ReactNode | undefined;

  /**
   * A class property to attach to the element.
   *
   * @see {@link !Element.className}
   */
  className?: string | undefined;
};

/**
 * A container element used to render the Project Notifications Configuration surface. This component
 * will take care of styling your component so it looks good in the **Project configuration > Notifications**
 * section of the Netlify UI.
 *
 * <!-- TODO(ndhoule): Add a screenshot here -->
 *
 * @param props
 * @see Surfaces.SiteNotificationsConfiguration
 * @example
 * ```tsx
 * import { SiteNotificationsConfigurationSurface } from "@netlify/sdk/react/components";
 *
 * <SiteNotificationsConfigurationSurface>
 *   <div>Your surface content goes here</div>
 * </SiteNotificationsConfigurationSurface>
 * ```
 */
export const SiteNotificationsConfigurationSurface = ({
  className,
  children,
  ...otherProps
}: SiteNotificationsConfigurationSurfaceProps) => {
  const sdk = useNetlifySDK();

  return (
    <section
      id={`section-${Surfaces.SiteNotificationsConfiguration}-${sdk.extension.slug}`}
      className={className}
      {...otherProps}
    >
      {children}
    </section>
  );
};
